'use strict';

// import ReadMoreReact from './components/ReadMoreReact';

// export default ReadMoreReact;


module.exports = require('./components/ReadMoreReact');